export const SMALL_GRID = 32;
export const BIG_GRID = 64;
export const createGrid = (size) =>
  Array(size)
    .fill([])
    .map(() => Array(size).fill(15));
